import { Component, Inject } from "@angular/core";
import { LocaleService, LocaleServiceToken } from "@core/locale/locale.module";
import { CoreActionFactory, CoreActionFactoryToken } from "@core/redux/redux.module";
import { ResourceService, ResourceServiceToken } from "@feature_core/resource/resource.module";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { selectCoreState } from "@core/redux/model/common/core.state.model";

@Component({
  selector: "card3dsecure-app-header",
  templateUrl: "./app-header.component.html"
})
export class AppFrameHeaderComponent {

  public langs = [];
  public selectedLang = null;
  private localService: LocaleService;
  private coreActionFactory: CoreActionFactory;
  private resources: ResourceService;
  private router: Router;

  constructor(
    @Inject(LocaleServiceToken)
      localeService: LocaleService,
    @Inject(CoreActionFactoryToken)
      coreActionFactory: CoreActionFactory,
    @Inject(ResourceServiceToken) resourceService: ResourceService,
    router: Router,
    ngrxStore: Store<any>
  ) {
      this.router = router;
      this.localService = localeService;
      this.coreActionFactory = coreActionFactory;
      this.resources = resourceService;
      ngrxStore.select(selectCoreState).subscribe( state => {
        this.applyResources(state);
      });
  }

  protected applyResources(state: any): void {
    if (!state.locale) {
      this.langs = [
        { title: this.resources.resolve("mkb.card3dsecure.common.lang.hu"), value: "hu"},
        { title: this.resources.resolve("mkb.card3dsecure.common.lang.en"), value: "en"}
      ];
      this.selectedLang = this.langs[this.localService.getLocale() === "hu" ? 0 : 1];
    }
  }

  selectionChange(event: any) {
    this.localService.setLocale(event.value.value);
    this.selectedLang = event.value;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = "reload";
    this.router.navigate(this.router.url.split("/"));
  }
}
